import toBlob from 'b64-to-blob';
import loadImage from './load';

export default async (file, options = {}) => {
  const resized = await loadImage(file, {
    ...options,
    canvas: true,
  });

  const resizedData = await resized.toDataURL(file.type);
  const blob = toBlob(
    resizedData.substr(resizedData.indexOf(',') + 1),
    file.type,
  );

  blob.name = file.name;

  return blob;
};



// WEBPACK FOOTER //
// ./src/Utils/Images/resizeFile.js